module.exports = __webpack_public_path__ + "static/media/ti.7fe85a20.svg";